import React from 'react'
import TooltipButton from '../tooltipButton'
import GeneralServices from '../../app/service/generalServices';
import AuthService from '../../app/service/authService';
import ConstantsUtil from '../../context/constantsUtil';

class VisualizarDanfeButton extends React.Component {

    constructor(){
        super()
        this.generalServices = new GeneralServices();
    }

    getTooltipFromTipo = () => {
        switch(this.props.tipo){

            case ConstantsUtil.tipoComponenteDigitalComprovanteProvisaoManual:
                return "Comprovante de Pagamento"

            case ConstantsUtil.tipoComponenteDigitalPdfNfse:
                return "PDF da NFSe"

            case ConstantsUtil.tipoComponenteDigitalDanfeNF:
            default:
                return "DANFE"

        }
    }

    render () {

        const actionViewDanfeNFButton = () => {
            if(
                (
                    AuthService.verificaConfiguracao(ConstantsUtil.ARMAZENA_PDF_DANFE)
                    || AuthService.verificaConfiguracao(ConstantsUtil.ARMAZENA_COMPROVANTE_PROVISAO)
                )
                && this.props.possuiArquivo
            ){
                return (
                    <TooltipButton
                        tooltip = {`Visualizar ${this.getTooltipFromTipo(this.props.tipo)}`}
                        className={`p-button-rounded p-button-${this.props.possuiArquivo ? 'danger' : 'secondary'} p-mr-2 right-button`}
                        icon="pi pi-file-pdf"
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                        // disabled={!this.props.possuiArquivo}
                        // onClick={() => this.viewDanfe(rowData)}
                        onClick={() => this.generalServices.buscaComponenteDigital(this.props.idComponenteDigital)}
                    />
                )
            }
            else{
                return (<></>)
            }
        }        

        return actionViewDanfeNFButton()
    }

}

export default VisualizarDanfeButton